import { createAsyncThunk } from '@reduxjs/toolkit';
import { ActionStatus } from '../../../common/constants/action-status';
import { StoreState } from '../../../store/store.interface';
import { getUserSelf } from '../api/get-user-self';
import { handleApiError, ApiError } from '../../../common/utils/api-utils';

export const updateUserSelf = createAsyncThunk(
  'userProfile/getUserSelf',
  async (_, thunkAPI) => {
    try {
      return await getUserSelf();
    } catch (error) {
      console.error(error);
      if (error instanceof ApiError) {
        handleApiError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  },
  {
    condition: (_arg, { getState }) => {
      const state = getState() as StoreState;
      return state.userProfileState.selfCall.status !== ActionStatus.loading;
    },
  }
);
